// 组件对象，大写
import readTextPlus from './readTextPlus.vue'
export default readTextPlus
